// Generated by GitHub Copilot
import { Api } from '#core/api/Api.ts'
import MfaApi from '#core/api/auth/MfaApi.ts'
import { setServiceWorkerToken } from '#core/auth/serviceWorkerToken.ts'
import AuthenticatorAppEnrollment from '#core/entities/auth/mfa/AuthenticatorAppEnrollment.ts'
import Token from '#core/entities/auth/accounts/Token.ts'

/** The signed-in account's authenticator-app MFA factor: setup, confirmation and removal. */
export default class AuthenticatorAppApi extends Api<AuthenticatorAppApi> {
  private static readonly basePath = `${MfaApi.basePath}/authenticator-app`

  /** Starts setting up an app, replacing a pending one; 409 once an app is confirmed, 503 `not_configured` without the server key. */
  public async enroll(): Promise<AuthenticatorAppEnrollment | null> {
    return this.post<AuthenticatorAppEnrollment>(AuthenticatorAppApi.basePath, undefined, AuthenticatorAppEnrollment)
  }

  /**
   * Confirms the pending app with its first code and stores the session it returns, which counts as
   * MFA. Throws 400 `mfa_invalid_code`, 403 `mfa_locked`, 404 with nothing pending, 409 when already confirmed.
   */
  public async confirm(code: string): Promise<Token> {
    const token = await this.post<Token>(`${AuthenticatorAppApi.basePath}/confirm`, { code }, Token)
    await setServiceWorkerToken({ ...token! })
    return token!
  }

  /** Removes the app; a confirmed one needs a session that proved MFA (403 `mfa_required`). */
  public async remove(): Promise<void> {
    await this.delete(AuthenticatorAppApi.basePath)
  }
}
